module.exports = __webpack_public_path__ + "static/img/footings.ddf3f7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footings.jpg
// module id = xkJW
// module chunks = 0